import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import Reports from './Reports';
import {
  generateReportClear,
  getAllReportsInitiate,
} from '../../actions/reports';
import { currentFlowTypeEnum } from '../common/components/constants';
import { getAllGroupsInitiate } from '../../actions/groups';
import {
  getCompanyInvoicesInitiate,
  getCompanyMappedOfficesInitiate,
} from '../../actions/company';

const mapStateToProps = state => {
  const reports = _get(state, 'reports', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  const isReportsTabEnabled = _get(
    state,
    'user.supported_features.reports_tab_enabled',
    false,
  );
  return {
    viewOnlyMode,
    isReportsTabEnabled,
    currentFlow,
    reports,
    selectedWorkspace,
    fetchingReports:
      _get(state, 'apiState.GET_ALL_REPORTS.isFetching', true) &&
      !_get(state, 'apiState.GET_ALL_REPORTS.isIdle', false),
    fetchedReports: _get(state, 'apiState.GET_ALL_REPORTS.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllReports: payload => dispatch(getAllReportsInitiate(payload)),
  getAllGroups: payload => dispatch(getAllGroupsInitiate(payload)),
  clearGenerateReport: () => dispatch(generateReportClear()),
  getAllCompanyMappedOffices: payload =>
    dispatch(getCompanyMappedOfficesInitiate(payload)),
  getCompanyInvoices: payload => dispatch(getCompanyInvoicesInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Reports);
